<template>
    <edit-view-base :filter="filter" :has-card-view="true" :cards="cards" :tabs="tabs" :main-form="mainForm" :claim-name="claimName" :api-method="apiMethod" :item-id="itemId" :refresh-key="refreshKey" :has-import="true" />
</template>

<script>
    export default {
        props: [
            'filter',
            'itemId',
            'refreshKey'
        ],

        components: {
            editViewBase: () => import('../components/EditViewBase')
        },

        data() {
            return {
                cards: [
                    { title: 'Chemical Purchase', apiMethod: 'ChemicalPurchases', form: () => import('../forms/ChemicalPurchaseForm'), items: [], filter: {}, dialog: false, isVisible: true, isMainCard: true },
                    { title: 'Site Treatment', apiMethod: 'SiteTreatments', parentForeignKey: 'chemicalPurchaseId', form: () => import('../forms/SiteTreatmentForm'), items: [], filter: {}, dialog: false, isVisible: true },
                    { title: 'Treatment', apiMethod: 'Treatments', parentForeignKey: 'chemicalPurchaseId', form: () => import('../forms/TreatmentForm'), items: [], filter: {}, dialog: false, isVisible: true },
                ],
                tabs: [
                    { text: 'Site Treatments', value: 'chemicalPurchaseId', isCard: true, table: () => import('../tables/SiteTreatmentsTable') },
                    { text: 'Treatments', value: 'chemicalPurchaseId', isCard: true, table: () => import('../tables/TreatmentsTable') },
                ],
                mainForm: () => import('../forms/ChemicalPurchaseForm'),
                claimName: 'ChemicalPurchases',
                apiMethod: 'ChemicalPurchases',
            }
        }
    };
</script>
